import { isMobile, isTablet, isIPad13 } from "react-device-detect";
import "./Index.scss";
import Unsupported from "./components/unsupported/Unsupported"; // Import the unsupported page
import AppDesktop from "./desktop/AppDesktop";

export default function App() {
  // Allow tablets (including iPads) to run the desktop version
  const isMobilePhone = isMobile && !isTablet && !isIPad13;

  if (isMobilePhone) {
    return <Unsupported />; // Render the unsupported page only for mobile phones
  }

  return <AppDesktop />;
}
